<template>
  <div class="content">

    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <div class="card-title" style="width: 100%;float: left"  @click="titleClick(twoTitle)">
        <img src="../assets/titleL.png" alt=""/>&nbsp;{{twoTitle }}&nbsp;<img
          src="../assets/titleR.png"
          alt=""
      />
      </div>
      <div class="recycle-record">
        <!-- 表头 -->
        <table class="record-table header-table" style="  border-radius: 15px 15px 0 0;
             background-color: #0390bc;"
        >
          <thead>
          <tr>
            <th class="short-col">分区</th>
            <th class="short-col">城市</th>
            <th class="wide-col">县（区）</th>
            <th class="short-col">面积(km2）</th>
            <th class="short-col">备注</th>
          </tr>
          </thead>
        </table>
        <!-- 内容（自动滚动） -->
        <div
            class="recycle-record-content"
            ref="scrollBox1"
            @mouseenter="pauseScroll(1)"
            @mouseleave="startScroll(1)"
        >
          <div class="scroll-inner" :style="{ transform: `translateY(-${scrollTop1}px)` }">
            <table class="record-table">
              <tbody>
              <template v-for="(group, gIndex) in groupedAreaData">
                <tr v-for="(line, i) in group.items" :key="gIndex + '-' + i">
                  <td v-if="i === 0" :rowspan="group.items.length" class="cell short-col type-cell">
                    {{ group.subarea }}
                  </td>
                  <td class="cell short-col">{{ line.city }}</td>
                  <td class="cell wide-col">{{ line.Country }}</td>
                  <td class="cell short-col">{{ line.area }}</td>
                  <td class="cell short-col">{{ line.remark2 }}</td>
                </tr>
              </template>
              </tbody>
            </table>
            <!-- 复制一份，实现无缝循环 -->
            <table class="record-table">
              <tbody>
              <template v-for="(group, gIndex) in groupedAreaData">
                <tr v-for="(line, i) in group.items" :key="gIndex + '-' + i">
                  <td v-if="i === 0" :rowspan="group.items.length" class="cell short-col type-cell">
                    {{ group.subarea }}
                  </td>
                  <td class="cell short-col">{{ line.city }}</td>
                  <td class="cell wide-col">{{ line.Country }}</td>
                  <td class="cell short-col">{{ line.area }}</td>
                  <td class="cell short-col">{{ line.remark2 }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 0px"></div>

    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <div class="card-title" style="width: 100%;float: left" @click="titleClick(oneTitle)">
        <img src="../assets/titleL.png" alt=""/>&nbsp;{{ oneTitle }}&nbsp;<img
          src="../assets/titleR.png"
          alt=""
      />
      </div>
      <div class="recycle-record">
        <!-- 表头 -->
        <table class="record-table header-table" style="  border-radius: 15px 15px 0 0;
             background-color: #0390bc;"
        >
          <thead>
          <tr>
            <th class="short-col">类型</th>
            <th class="wide-col">对象</th>
            <th class="short-col">取水量
              （万m³）</th>
            <th class="short-col">备注</th>
          </tr>
          </thead>
        </table>

        <!-- 内容（自动滚动） -->
        <div
            class="recycle-record-content"
            ref="scrollBox2"
            @mouseenter="pauseScroll(2)"
            @mouseleave="startScroll(2)"
        >
          <div class="scroll-inner" :style="{ transform: `translateY(-${scrollTop2}px)` }">
            <table class="record-table">
              <tbody>
              <template v-for="(group, gIndex) in groupedData">
                <tr v-for="(line, i) in group.items" :key="gIndex + '-' + i">
                  <td v-if="i === 0" :rowspan="group.items.length" class="cell short-col type-cell">
                    {{ group.type }}
                  </td>
                  <td class="cell wide-col">{{ line.supplyObject }}</td>
                  <td class="cell short-col">{{ line.flow }}</td>
                  <td class="cell short-col">{{ line.remark }}</td>
                </tr>
              </template>
              </tbody>
            </table>
            <!-- 复制一份，实现无缝循环 -->
            <table class="record-table">
              <tbody>
              <template v-for="(group, gIndex) in groupedData">
                <tr v-for="(line, i) in group.items" :key="'copy-' + gIndex + '-' + i">
                  <td v-if="i === 0" :rowspan="group.items.length" class="cell short-col type-cell">
                    {{ group.type }}
                  </td>
                  <td class="cell wide-col">{{ line.supplyObject }}</td>
                  <td class="cell short-col">{{ line.flow }}</td>
                  <td class="cell short-col">{{ line.remark }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>

      </div>

    </div>

    <div style="width: 100%; height: 0px"></div>

    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <div class="card-title" style="width: 100%;float: left" @click="titleClick(threeTitle)">
        <img src="../assets/titleL.png" alt=""/>&nbsp;{{ threeTitle }}&nbsp;
        <img src="../assets/titleR.png" alt=""/>
      </div>

      <div class="recycle-record">
        <!-- 表头 -->
        <table class="record-table header-table"
               style="border-radius: 15px 15px 0 0; background-color: #0390bc;">
          <thead>
          <tr>
            <th class="short-col">站名</th>
            <th class="short-col">降雨日期</th>
            <th class="short-col">最大降雨量（mm/h）</th>
            <th class="short-col">降水等级</th>
          </tr>
          </thead>
        </table>

        <!-- 内容（自动滚动） -->
        <div class="recycle-record-content"
             ref="scrollBox3"
             @mouseenter="pauseScroll(3)"
             @mouseleave="startScroll(3)"
        >
          <div class="scroll-inner" :style="{ transform: `translateY(-${scrollTop3}px)` }">

            <!-- 第一份内容 -->
            <table class="record-table">
              <tbody>
              <tr v-for="(line, i) in model" :key="'m-'+i"
                  :style="{ backgroundColor: line.rain >= 90 ? 'red' : '' }"
                  @click="line.rain>=90 ? addRain(line) : ''"
              >
                <td class="cell short-col">{{ line.name }}</td>
                <td class="cell short-col">{{ line.time }}</td>
                <td class="cell short-col">{{ line.rain }}</td>
                <td class="cell short-col">
                  <img :src="line.rate" alt="" style="height: 30px;width: 30px"/>
                </td>
              </tr>
              </tbody>
            </table>

            <!-- 第二份内容（用于无缝循环） -->
            <table class="record-table">
              <tbody>
              <tr v-for="(line, i) in model" :key="'copy-m-'+i"
                  :style="{ backgroundColor: line.rain >= 90 ? 'red' : '' }"
                  @click="line.rain>=90 ? addRain(line) : ''"
              >
                <td class="cell short-col">{{ line.name }}</td>
                <td class="cell short-col">{{ line.time }}</td>
                <td class="cell short-col">{{ line.rain }}</td>
                <td class="cell short-col">
                  <img :src="line.rate" alt="" style="height: 30px;width: 30px"/>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; height: 0px"></div>



    <div style="width: 100%; height: calc(25% - 0px)" class="card">
      <p class="card-title">
        <img src="../assets/titleL.png" />&nbsp;水质污染监测&nbsp;
        <img src="../assets/titleR.png" />
      </p>

      <div class="recycle-record">
        <div class="recycle-record-title">
          <div style="width: 19%; float: left; text-align: center">监测点</div>
          <div style="width: 20%; float: left; text-align: center">断面</div>
          <div style="width: 20%; float: left; text-align: center">主要指标</div>
          <div style="width: 20%; float: left; text-align: center">预警等级</div>
          <div style="width: 20%; float: left; text-align: center">自动预警</div>
        </div>

        <div class="recycle-record-content"
             ref="qualityContent"
             @mouseenter="mEnterQuality"
             @mouseleave="mLeaveQuality">

          <!-- 滚动层 -->
          <div :style="{ transform: `translate(0px,-${qualityScrollTop}px)` }">

            <!-- 第一份内容（真实列表） -->
            <div class="recycle-record-content-line"
                 v-for="(item, i) in waterQuality"
                 :key="i">

              <div class="recycle-record-content-item"
                   :title="item.name"
                   style="width: 18%; float: left; text-align: center">
                {{ item.name }}
              </div>

              <div class="recycle-record-content-item"
                   :title="item.section"
                   style="width: 20%; float: left; text-align: center">
                {{ item.section }}
              </div>

              <div class="recycle-record-content-item"
                   :title="item.scale"
                   style="width: 20%; float: left; text-align: center">
                {{ item.scale }}
              </div>

              <div class="recycle-record-content-item"
                   style="width: 20%; float: left; text-align: center">
                <el-tag
                    :type="item.level=='蓝'?'info':item.level=='黄'?'warning':'danger'"
                    effect="dark">
                  {{ item.level }}
                </el-tag>
              </div>

              <div class="recycle-record-content-item"
                   style="width: 20%; float: left; text-align: center">
                <el-switch
                    v-model="item.auto"
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-switch>
              </div>

            </div>

            <!-- 第二份内容 copyHtml，用于无缝滚动 -->
            <div v-html="copyQualityHtml"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import date from "@/utils/dateFormate";
import { WarningService } from '@/services/warningService.js'


export default {
  name: "leftBoard",
  data() {
    return {
      oneTitle: "水量配置方案",
      twoTitle: "陕西供水范围",
      threeTitle: "降雨预警信息",
      scrollTimer4: null,
      scrollTop1: 0,
      scrollTop2: 0,
      scrollTop3: 0,
      scrollTimer1: null,
      scrollTimer2: null,
      scrollTimer3: null,
      waterQuality: [
        { name: "取水口A", section: "入口监测点", scale: "pH7.2 | NTU1.2 | DO8.5", level: "蓝", auto: true },
        { name: "调蓄水库北区", section: "北区断面", scale: "pH6.5 | NTU3.8 | DO6.2", level: "黄", auto: true },
        { name: "输水渠道三号段", section: "3号段", scale: "pH8.1 | NTU6.1 | DO4.3", level: "橙", auto: false },
        { name: "调蓄水库东区", section: "东区断面", scale: "pH9.0 | NTU8.3 | DO3.5", level: "红", auto: false }
      ],
      qualityScrollTop: 0,
      copyQualityHtml: "",
      qualityTimer: null,
      areaData: [
        { subarea: "陕北", city: "延安市", Country: "宜川", area: 2945, remark2: "1个县" },
        { subarea: "关中东部供水", city: "渭南市", Country: "韩城、合阳、澄城、大荔、蒲城、白水、临渭、富平", area:10801, remark2: "8个县（市、区）" },
        { subarea: "关中东部供水", city: "咸阳市", Country: "泾阳、三原", area:1427, remark2: "2个县" },
        { subarea: "关中东部供水", city: "西安市", Country: "高陵、阎良、临潼", area:1361, remark2: "3个区" },
        { subarea: "合计", city: "4个地市", Country: "14个县（市、区）", area: 16543, remark2: "14个县（市、区）" },

      ],
      model: [],


      forecastDays: ["明天", "后天", "3天后", "4天后", "5天后", "6天后", "7天后"],
      supplyScheme: [
        {
          type: "城市",
          supplyObject: "渭南市、韩城市和宜川、合阳、澄城、大荔、富平、蒲城、白水7个县城",
          flow: 22962,
          remark: "全部（9个县城）"
        }, {
          type: "农村人饮",
          supplyObject: "宜川、韩城、合阳、澄城、大荔、富平、蒲城、白水8个县",
          flow: 4633,
          remark: "全部（8县61个镇"
        }, {
          type: "工业园区",
          supplyObject: "宜川县秋林核心区+范湾产业集聚区",
          flow: 213,
          remark: ""
        }, {
          type: "工业园区",
          supplyObject: "宜川县集义物流园区",
          flow: 92,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "宜川县交里（云岩）天然气加工区",
          flow: 172,
          remark: ""
        }, {
          type: "工业园区",
          supplyObject: "韩城高新技术产业开发区",
          flow: 37,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "韩城龙亭空铁物流创新产业园",
          flow: 908,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "韩城经济技术开发区",
          flow: 4424,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "合阳经济技术开发区",
          flow: 634,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "澄城县经济技术开发区",
          flow: 1178,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "富平高新技术产业开发区",
          flow: 6238,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "富平庄里工业园区",
          flow: 4084,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "富平北部建材产业区",
          flow: 555,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "白水县高新技术产业开发区",
          flow: 1441,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "卤阳湖现代产业综合开发区",
          flow: 3611,
          remark: "全部(16个)"
        }, {
          type: "工业园区",
          supplyObject: "蒲城高新技术产业开发区",
          flow: 7012,
          remark: "全部(16个)"
        }, {
          type: "农灌",
          supplyObject: "东雷一期",
          flow: 28011,
          remark: "102.00 万亩"
        }, {
          type: "农灌",
          supplyObject: "东雷二期",
          flow: 23541,
          remark: "85.50 万亩"
        }, {
          type: "农灌",
          supplyObject: "石堡川",
          flow: 3557,
          remark: "16.40 万亩"
        }, {
          type: "农灌",
          supplyObject: "交口",
          flow: 7878,
          remark: "28.89 万亩"
        }, {
          type: "农灌",
          supplyObject: "泾惠渠",
          flow: 3128,
          remark: "11.00 万亩"
        }, {
          type: "农灌",
          supplyObject: "洛惠渠",
          flow: 4442,
          remark: "20.00 万亩"
        }, {
          type: "农灌",
          supplyObject: "桃曲坡",
          flow: 6036,
          remark: "23.12 万亩"
        }, {
          type: "农灌",
          supplyObject: "薛峰",
          flow: 799,
          remark: "3.10 万亩"
        }, {
          type: "农灌",
          supplyObject: "林皋",
          flow: 953,
          remark: "4.00 万亩"
        }, {
          type: "农灌",
          supplyObject: "龙阳",
          flow: 1595,
          remark: "5.60 万亩"
        }, {
          type: "农灌",
          supplyObject: "禹门口灌区",
          flow: 451,
          remark: "1.75 万亩"
        }, {
          type: "农灌",
          supplyObject: "红旗水库灌区",
          flow: 593,
          remark: "2.22 万亩"
        }, {
          type: "农灌",
          supplyObject: "盘河灌区",
          flow: 438,
          remark: "1.70 万亩"
        }, {
          type: "农灌",
          supplyObject: "下寨灌区",
          flow: 627,
          remark: "2.20 万亩"
        }, {
          type: "农灌",
          supplyObject: "石羊抽水灌区",
          flow: 740,
          remark: "2.60 万亩"
        }, {
          type: "农灌",
          supplyObject: "韩河灌区",
          flow: 683,
          remark: "2.40 万亩"
        }, {
          type: "农灌",
          supplyObject: "温泉灌区",
          flow: 522,
          remark: "2.50 万亩"
        }, {
          type: "农灌",
          supplyObject: "大荔县五万亩以下中型灌区",
          flow: 2347,
          remark: "10.06 万亩"
        }, {
          type: "农灌",
          supplyObject: "蒲城县五万亩以下中型灌区",
          flow: 954,
          remark: "3.35 万亩"
        }, {
          type: "农灌",
          supplyObject: "澄城县五万亩以下中型灌区",
          flow: 836,
          remark: "4.00 万亩"
        }, {
          type: "农灌",
          supplyObject: "白水县五万亩以下中型灌区",
          flow: 276,
          remark: "1.30万亩"
        }, {
          type: "农灌",
          supplyObject: "合阳县五万亩以下中型灌区",
          flow: 1029,
          remark: "3.85 万亩"
        }, {
          type: "农灌",
          supplyObject: "合阳扩灌区",
          flow: 9727,
          remark: "38.71 万亩"
        }, {
          type: "农灌",
          supplyObject: "澄城扩灌区",
          flow: 4071,
          remark: "19.76 万亩"
        }, {
          type: "农灌",
          supplyObject: "富平扩灌区",
          flow: 6636,
          remark: "26.10 万亩"
        }, {
          type: "农灌",
          supplyObject: "蒲城扩灌区",
          flow: 8254,
          remark: "32.46 万亩"
        }, {
          type: "农灌",
          supplyObject: "白水县扩灌区",
          flow: 5179,
          remark: "23.27万亩"
        }, {
          type: "农灌",
          supplyObject: "韩城扩灌区",
          flow: 826,
          remark: "3.50 万亩"
        }, {
          type: "农灌",
          supplyObject: "宜川扩灌区",
          flow: 2072,
          remark: "10.00万亩"
        }
      ],
    };
  },
  computed: {
    // 按 type 分组
    groupedAreaData() {
      const groups = {};
      this.areaData.forEach(item => {
        if (!groups[item.subarea]) {
          groups[item.subarea] = { subarea: item.subarea, items: [] };
        }
        groups[item.subarea].items.push(item);
      });
      return Object.values(groups);
    },
    groupedData() {
      const groups = {};
      this.supplyScheme.forEach(item => {
        if (!groups[item.type]) {
          groups[item.type] = {type: item.type, items: []};
        }
        groups[item.type].items.push(item);
      });
      return Object.values(groups);
    }
  },
  mounted() {
    this.time = date(new Date()).slice(0, 11)
    this.startScroll(1);
    this.startScroll(2);
    this.startScroll(3);
    this.scrollQuality();
  },

  beforeDestroy() {
    this.clearScroll(1);
    this.clearScroll(2);
    this.clearScroll(3);
    if (this._warningTimer) clearInterval(this._warningTimer)
  },
  created() {
    this._warningService = new WarningService()
    this._refreshData()
    this._warningTimer = setInterval(() => this._refreshData(), 8000)
  },
  methods: {
    // 开始滚动
    startScroll(tableIndex) {
      this.clearScroll(tableIndex);
      const box = this.$refs[`scrollBox${tableIndex}`];
      if (!box) return;
      const scrollHeight = box.scrollHeight / 2;

      this[`scrollTimer${tableIndex}`] = setInterval(() => {
        this[`scrollTop${tableIndex}`] += 1;
        if (this[`scrollTop${tableIndex}`] >= scrollHeight) {
          this[`scrollTop${tableIndex}`] = 0;
        }
      }, 30);
    },
    scrollQuality() {
      const content = this.$refs.qualityContent;

      // 复制里面的 HTML（只复制一次！）
      this.copyQualityHtml = content.children[0].innerHTML;

      if (this.qualityTimer) clearInterval(this.qualityTimer);

      this.qualityTimer = setInterval(() => {
        this.qualityScrollTop += 1;

        // 高度通过 scrollHeight 判断
        if (this.qualityScrollTop >= content.scrollHeight) {
          this.qualityScrollTop = 0;
        }
      }, 40);
    },

    mEnterQuality() {
      clearInterval(this.qualityTimer);
    },
    mLeaveQuality() {
      this.scrollQuality();
    },
    getToday () {
      const d = new Date();
      const y = d.getFullYear();
      const m = ("0" + (d.getMonth() + 1)).slice(-2);
      const day = ("0" + d.getDate()).slice(-2);
      return `${y}-${m}-${day}`;
    },
    pauseScroll(tableIndex) {
      this.clearScroll(tableIndex);
    },
    clearScroll(tableIndex) {
      const key = `scrollTimer${tableIndex}`;
      if (this[key]) {
        clearInterval(this[key]);
        this[key] = null;
      }
    },
    addRain(line){
      if (line.rain>=70){
        this.$emit('flyRing')
      }
    },
    titleClick(title){
      this.$emit('openLeftCard',title)
    },

    _refreshData() {
      if (this._warningService) {
        this.model = this._warningService.getSimulatedRainfallData()
        this.waterQuality = this._warningService.getSimulatedWaterQuality()
      }
    },



  },

};
</script>

<style scoped>
.content {
  width: 23.49%;
  height: calc(100vh - 80px);
  position: absolute;
  left: 10px;
  top: 60px;
}


.recycle-record-content {
  max-height: 400px;
  overflow: auto;
  position: relative;
}


.cell {
  color: #00F2F8;
  text-align: center;
  padding: 6px;
  vertical-align: middle;  /* 垂直居中 */
  text-align: center;
}

/* 对象列：更宽 */
.wide-col {
  width: 50%;
  text-align: center;
  padding-left: 8px;
}

/* 其他列：较窄 */
.short-col {
  width: 16%;
}

.record-table {
  text-align: center;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.header-table th {
  text-align: center;
  font-weight: bold;
}


/* 列宽分配 */
.wide-col {
  width: 40%;
  text-align: left;
  padding-left: 8px;
}

.short-col {
  width: 16%;
}


</style>


